<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-31 16:50:13
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-12-20 20:08:42
-->
<template>
	<div>
		<el-dialog title="修改合作状态" :visible.sync="dialogVisible" width="426px" :before-close="handleClose">
			<span v-if="type === 'group' && length" class="yx-color-text-primary mb-20">
				已选择 <span class="yx-color-primary">{{ length }} </span> 个达人, 其中
				<span class="yx-color-primary"> {{ multiFollow }} </span> 个达人存在多商务跟进, 多商务跟进达人请前往
				<span class="yx-color-primary">「我的达人」 </span>菜单下修改合作状态, 若继续操作将仅修改单商务跟进达人的合作状态
			</span>
			<p class="yx-color-text-primary mb-20" v-if="type === 'myTalent'">
				已选择 <span class="yx-color-primary"> {{ length }} </span>个达人
			</p>
			<el-form :model="form" :rules="rules" ref="form" label-width="82px">
				<el-form-item label="合作状态" prop="cooperateStatus">
					<el-select v-model="form.cooperateStatus" clearable filterable style="width: 250px">
						<el-option v-for="(item, index) in cooperationStatusList" :key="index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="ok">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="tipsVisible" width="360px" :before-close="close">
			<p class="yx-color-text-primary mb-20"> 确认是否继续当前修改? </p>
			<span slot="footer">
				<el-button @click="close">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { partnerAnchorBatchModify, teamAnchorBatchModify, partnerModifyCooperate, teamModifyCooperate } from '@/api/talentCRM';
export default {
	name: 'modifyCooperationStatus',
	data() {
		return {
			dialogVisible: false,
			tipsVisible: false,
			length: 1,
			form: {
				cooperateStatus: '',
			},
			rules: {
				cooperateStatus: { required: true, message: '请选择合作状态', trigger: 'change' },
			},
			partnerAnchorId: '',
			type: '',
			multiFollow: 0,
			partnerAnchorIds: [],
			isBatch: false,
			cooperationStatusList: [
				{ value: '1', label: '线索' },
				{ value: '2', label: '已建联' },
				{ value: '3', label: '已申样' },
				{ value: '4', label: '已成交' },
			],
		};
	},
	computed: {},
	props: {
		source: {
			type: String,
			default: 'public',
		},
	},
	methods: {
		show(partnerAnchorId = '', partnerAnchorIds = [], multiFollow = 0, type = '') {
			this.partnerAnchorId = partnerAnchorId;
			this.partnerAnchorIds = partnerAnchorIds;
			this.length = partnerAnchorIds.length;
			this.isBatch = !partnerAnchorId;
			this.multiFollow = multiFollow;
			this.type = type;
			this.dialogVisible = true;
		},
		ok() {
			this.$refs.form.validate(valid => {
				if (!valid) return;
				this.tipsVisible = true;
			});
		},
		async confirm() {
			const {
				partnerAnchorIds,
				form: { cooperateStatus },
				partnerAnchorId,
				isBatch,
				source,
			} = this;
			let batchParams = {
				public: { anchorIds: partnerAnchorIds, cooperateStatus },
				private: { partnerAnchorIds, cooperateStatus },
			};
			let params = {
				public: { anchorId: partnerAnchorId, cooperateStatus },
				private: { cooperateStatus, partnerAnchorId },
			};
			const { code, data } = await this.modifyApi()(isBatch ? batchParams[source] : params[source]);
			if (code !== 0) return;
			if (isBatch) {
				const { success = 0, fail = 0, failList = [], exception = '' } = data;
				if (exception) {
					this.$message.warning(`${success}个达人合作状态修改成功, ${exception}`);
				} else if (fail === 0) {
					this.$message.success(`${success}个达人合作状态修改成功`);
				} else if (fail !== 0) {
					let str = '';
					failList.forEach(item => {
						str += `${item.count}个达人修改失败因${item.msg}`;
					});
					this.$message.success(`${success}个达人修改成功, ${str}`);
				}
			} else {
				this.$message.success(`修改成功`);
			}
			this.tipsVisible = false;
			this.handleClose();
			this.$emit('refresh');
		},
		modifyApi() {
			const { isBatch, source } = this;
			let batchApi = {
				public: teamAnchorBatchModify,
				private: partnerAnchorBatchModify,
			};
			let api = {
				public: teamModifyCooperate,
				private: partnerModifyCooperate,
			};

			return isBatch ? batchApi[source] : api[source];
		},
		close() {
			this.tipsVisible = false;
		},
		handleClose() {
			this.$refs.form.resetFields();
			this.dialogVisible = false;
			this.form = {
				cooperateStatus: '',
			};
		},
	},
};
</script>

<style lang="less" scoped></style>
